// Material Dashboard 2 React helper functions
import pxToRem from "../../functions/pxToRem";
const dialogActions = {
  styleOverrides: {
    root: {
      padding: pxToRem(16),
    },
  },
};

export default dialogActions;
